import { render } from "./PlanosView.vue?vue&type=template&id=6218d56a"
import script from "./PlanosView.vue?vue&type=script&lang=js"
export * from "./PlanosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__